<slate-string-template #templateComponent></slate-string-template>
